import { render, staticRenderFns } from "./confirm-password.vue?vue&type=template&id=e2013850&scoped=true&"
import script from "./confirm-password.vue?vue&type=script&lang=js&"
export * from "./confirm-password.vue?vue&type=script&lang=js&"
import style0 from "./confirm-password.vue?vue&type=style&index=0&id=e2013850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2013850",
  null
  
)

export default component.exports